import React, { Fragment } from "react";
import { Badge }  from "reactstrap";
import moment from 'moment'

import BetImg    from "~/assets/images/dailyGoals/lottery.png";

import Bet from "~/services/bet";


const BetCard = ({item})=> {

  const formatDate = (date)=> moment(date).format("YYYY-MM-DD");

  return (
    <Fragment>
      <img src={BetImg} />

      <div className="item-details">
        <div>
          <h6> Jackpot </h6>
          <Badge color="points"> {item.rewardType === Bet.betType.POINTS ? "POINTS" : "TOKENS"}: {item.rewardValue} </Badge>
        </div>
        <div>
          <h6> { formatDate(item.createdAt) } </h6>
          {item.isWin
            ? <Badge color="custom-completed"> WIN </Badge>
            : <Badge color="custom-reversal"> LOOSE </Badge>
          }
        </div>
      </div>
    </Fragment>
  );
};


export default BetCard;
